import React from 'react';
import { CheckIcon } from 'lucide-react';
export function TransformationSection() {
  const benefits = [{
    title: 'PASO 1:',
    description: 'Crear tu producto desde 0'
  }, {
    title: 'PASO 2:',
    description: 'Configurar tu tienda de shopify y dejarla lista para vender'
  }, {
    title: 'PASO 3:',
    description: 'Diseñar tu pagina de ventas'
  }, {
    title: 'PASO 4:',
    description: 'Lanzar tus campañas de ventas'
  }];
  return <section className="py-8 md:py-12 px-4 bg-[#2F0240] pt-[40px] pb-[40px] mt-[-20px] mb-[-20px] space-y-[16px]" data-id="element-367">
      <div className="max-w-5xl mx-auto pt-[10px] pb-[10px] mt-[-15px] mb-[-15px]" data-id="element-368">
        <div className="rounded-2xl p-8 md:p-12 mb-8 bg-[#FFFFFF] animate-neon-violet" data-id="element-369">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-370">
            EN 1 FINDE SEMANA VAS A APRENDER A👇
          </p>

          <div className="space-y-4" data-id="element-371">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 rounded-lg p-4 shadow-sm bg-[#FAC7F3B1]" data-id="element-372">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-373" />
                <span className="text-lg text-gray-700" data-id="element-374">
                  <span className="font-black uppercase text-[#353135]" data-id="element-375">
                    {benefit.title}
                  </span>{' '}
                  {benefit.description}
                </span>
              </div>)}
          </div>
        </div>

        <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-12 text-center pt-[20px] pb-[20px] mt-[-20px] mb-[-20px]" data-id="element-376">
          <p className="text-xl md:text-2xl mb-4 font-[400]" data-id="element-377">
            No prometemos magia. No es "apretar un botón"
          </p>
          <p className="md:text-3xl font-black text-[#FC9DFF] text-[26px]" data-id="element-378">
            Prometemos una metodología probada que SÍ funciona✅
          </p>
        </div>
      </div>
    </section>;
}